import _slicedToArray from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _inherits from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/buildhome/.yarn_cache/@babel-runtime-npm-7.15.4-52ce5bf6ea-c408254304.zip/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/esnext.global-this.js";
import { int64fromString, int64toString } from "./goog-varint";
var BI;
export function detectBi() {
  var dv = new DataView(new ArrayBuffer(8));
  var ok = globalThis.BigInt !== undefined && typeof dv.getBigInt64 === "function" && typeof dv.getBigUint64 === "function" && typeof dv.setBigInt64 === "function" && typeof dv.setBigUint64 === "function";
  BI = ok ? {
    MIN: BigInt("-9223372036854775808"),
    MAX: BigInt("9223372036854775807"),
    UMIN: BigInt("0"),
    UMAX: BigInt("18446744073709551615"),
    C: BigInt,
    V: dv
  } : undefined;
}
detectBi();

function assertBi(bi) {
  if (!bi) throw new Error("BigInt unavailable, see https://github.com/timostamm/protobuf-ts/blob/v1.0.8/MANUAL.md#bigint-support");
} // used to validate from(string) input (when bigint is unavailable)


var RE_DECIMAL_STR = /^-?[0-9]+$/; // constants for binary math

var TWO_PWR_32_DBL = 0x100000000;
var HALF_2_PWR_32 = 0x080000000; // base class for PbLong and PbULong provides shared code

var SharedPbLong = /*#__PURE__*/function () {
  /**
   * Create a new instance with the given bits.
   */
  function SharedPbLong(lo, hi) {
    _classCallCheck(this, SharedPbLong);

    this.lo = lo | 0;
    this.hi = hi | 0;
  }
  /**
   * Is this instance equal to 0?
   */


  _createClass(SharedPbLong, [{
    key: "isZero",
    value: function isZero() {
      return this.lo == 0 && this.hi == 0;
    }
    /**
     * Convert to a native number.
     */

  }, {
    key: "toNumber",
    value: function toNumber() {
      var result = this.hi * TWO_PWR_32_DBL + (this.lo >>> 0);
      if (!Number.isSafeInteger(result)) throw new Error("cannot convert to safe number");
      return result;
    }
  }]);

  return SharedPbLong;
}();
/**
 * 64-bit unsigned integer as two 32-bit values.
 * Converts between `string`, `number` and `bigint` representations.
 */


export var PbULong = /*#__PURE__*/function (_SharedPbLong) {
  _inherits(PbULong, _SharedPbLong);

  var _super = _createSuper(PbULong);

  function PbULong() {
    _classCallCheck(this, PbULong);

    return _super.apply(this, arguments);
  }

  _createClass(PbULong, [{
    key: "toString",
    value:
    /**
     * Convert to decimal string.
     */
    function toString() {
      return BI ? this.toBigInt().toString() : int64toString(this.lo, this.hi);
    }
    /**
     * Convert to native bigint.
     */

  }, {
    key: "toBigInt",
    value: function toBigInt() {
      assertBi(BI);
      BI.V.setInt32(0, this.lo, true);
      BI.V.setInt32(4, this.hi, true);
      return BI.V.getBigUint64(0, true);
    }
  }], [{
    key: "from",
    value:
    /**
     * Create instance from a `string`, `number` or `bigint`.
     */
    function from(value) {
      if (BI) // noinspection FallThroughInSwitchStatementJS
        switch (typeof value) {
          case "string":
            if (value == "0") return this.ZERO;
            if (value == "") throw new Error('string is no integer');
            value = BI.C(value);

          case "number":
            if (value === 0) return this.ZERO;
            value = BI.C(value);

          case "bigint":
            if (!value) return this.ZERO;
            if (value < BI.UMIN) throw new Error('signed value for ulong');
            if (value > BI.UMAX) throw new Error('ulong too large');
            BI.V.setBigUint64(0, value, true);
            return new PbULong(BI.V.getInt32(0, true), BI.V.getInt32(4, true));
        } else switch (typeof value) {
        case "string":
          if (value == "0") return this.ZERO;
          value = value.trim();
          if (!RE_DECIMAL_STR.test(value)) throw new Error('string is no integer');

          var _int64fromString = int64fromString(value),
              _int64fromString2 = _slicedToArray(_int64fromString, 3),
              minus = _int64fromString2[0],
              lo = _int64fromString2[1],
              hi = _int64fromString2[2];

          if (minus) throw new Error('signed value for ulong');
          return new PbULong(lo, hi);

        case "number":
          if (value == 0) return this.ZERO;
          if (!Number.isSafeInteger(value)) throw new Error('number is no integer');
          if (value < 0) throw new Error('signed value for ulong');
          return new PbULong(value, value / TWO_PWR_32_DBL);
      }
      throw new Error('unknown value ' + typeof value);
    }
  }]);

  return PbULong;
}(SharedPbLong);
/**
 * ulong 0 singleton.
 */

PbULong.ZERO = new PbULong(0, 0);
/**
 * 64-bit signed integer as two 32-bit values.
 * Converts between `string`, `number` and `bigint` representations.
 */

export var PbLong = /*#__PURE__*/function (_SharedPbLong2) {
  _inherits(PbLong, _SharedPbLong2);

  var _super2 = _createSuper(PbLong);

  function PbLong() {
    _classCallCheck(this, PbLong);

    return _super2.apply(this, arguments);
  }

  _createClass(PbLong, [{
    key: "isNegative",
    value:
    /**
     * Do we have a minus sign?
     */
    function isNegative() {
      return (this.hi & HALF_2_PWR_32) !== 0;
    }
    /**
     * Negate two's complement.
     * Invert all the bits and add one to the result.
     */

  }, {
    key: "negate",
    value: function negate() {
      var hi = ~this.hi,
          lo = this.lo;
      if (lo) lo = ~lo + 1;else hi += 1;
      return new PbLong(lo, hi);
    }
    /**
     * Convert to decimal string.
     */

  }, {
    key: "toString",
    value: function toString() {
      if (BI) return this.toBigInt().toString();

      if (this.isNegative()) {
        var n = this.negate();
        return '-' + int64toString(n.lo, n.hi);
      }

      return int64toString(this.lo, this.hi);
    }
    /**
     * Convert to native bigint.
     */

  }, {
    key: "toBigInt",
    value: function toBigInt() {
      assertBi(BI);
      BI.V.setInt32(0, this.lo, true);
      BI.V.setInt32(4, this.hi, true);
      return BI.V.getBigInt64(0, true);
    }
  }], [{
    key: "from",
    value:
    /**
     * Create instance from a `string`, `number` or `bigint`.
     */
    function from(value) {
      if (BI) // noinspection FallThroughInSwitchStatementJS
        switch (typeof value) {
          case "string":
            if (value == "0") return this.ZERO;
            if (value == "") throw new Error('string is no integer');
            value = BI.C(value);

          case "number":
            if (value === 0) return this.ZERO;
            value = BI.C(value);

          case "bigint":
            if (!value) return this.ZERO;
            if (value < BI.MIN) throw new Error('signed long too small');
            if (value > BI.MAX) throw new Error('signed long too large');
            BI.V.setBigInt64(0, value, true);
            return new PbLong(BI.V.getInt32(0, true), BI.V.getInt32(4, true));
        } else switch (typeof value) {
        case "string":
          if (value == "0") return this.ZERO;
          value = value.trim();
          if (!RE_DECIMAL_STR.test(value)) throw new Error('string is no integer');

          var _int64fromString3 = int64fromString(value),
              _int64fromString4 = _slicedToArray(_int64fromString3, 3),
              minus = _int64fromString4[0],
              lo = _int64fromString4[1],
              hi = _int64fromString4[2];

          if (minus) {
            if (hi > HALF_2_PWR_32 || hi == HALF_2_PWR_32 && lo != 0) throw new Error('signed long too small');
          } else if (hi >= HALF_2_PWR_32) throw new Error('signed long too large');

          var pbl = new PbLong(lo, hi);
          return minus ? pbl.negate() : pbl;

        case "number":
          if (value == 0) return this.ZERO;
          if (!Number.isSafeInteger(value)) throw new Error('number is no integer');
          return value > 0 ? new PbLong(value, value / TWO_PWR_32_DBL) : new PbLong(-value, -value / TWO_PWR_32_DBL).negate();
      }
      throw new Error('unknown value ' + typeof value);
    }
  }]);

  return PbLong;
}(SharedPbLong);
/**
 * long 0 singleton.
 */

PbLong.ZERO = new PbLong(0, 0);